import React, { Fragment, useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import WorkflowPhase from "../../types/WorkflowPhase";
import WorkPhase from "./WorkPhase";
import ShowDesignerTool from "./ShowDesignerTool";
import { ProcessStep } from "../../types/ProcessStep";
import { Link } from "react-router-dom";
import ProjectContext from "../../context/project/ProjectContext";

export default function ProcessStepper(props: {
  phase: WorkflowPhase;
  step: number;
  projectId?: string;
  updateCallback?: (status: string) => void;
}) {
  const projectContext = useContext(ProjectContext);
  const { getUserRoleType, hasUserAccessToProject } = projectContext;
  const [activeStep, setActiveStep] = React.useState(0);
  const [phaseStatus, setPhaseStatus] = React.useState();
  const [activeWorkflow, setActiveWorkflow] =
    React.useState<WorkflowPhase | null>();

  const [openDesignTool, setOpenDesignTool] = React.useState(false);
  const [projectId, setProjectId] = React.useState(
    props.projectId ? props.projectId : "0"
  );

  const handleClickOpenDesignTool = () => {
    // setOpenDesignTool(true);
    window.open(
      `${process.env.REACT_APP_EXP_DESIGN}&projectId=${projectId}`,
      "_blank"
    );
    // window.location.replace(
    //   `${process.env.REACT_APP_EXP_DESIGN}&projectId=${projectId}`
    // );
  };

  const handleDesignToolClose = () => {
    setOpenDesignTool(false);
  };

  // const handleNext = (event: React.MouseEvent<HTMLElement>) => {
  //   console.log(`Current Step:`, event);
  //   console.log(`Current Step:`, event.currentTarget);
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  const handleNext = async (step: ProcessStep) => {
    console.log(`Current Step:`, step);
    // console.log(`Current Step:`, event);
    try {
      if (props.updateCallback) await props.updateCallback(step.Name);
      // console.log(`Current Step:`, event.currentTarget);
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } catch (error) {}
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    //eslint-disable-next-line
    console.log("Active Step:", activeStep);
  }, [activeStep]);

  useEffect(() => {
    const _viewPhase: number = props.phase.PhaseOrder
      ? props.phase.PhaseOrder - 1
      : 0;
    console.log("Active Step:", props.step, "_viewPhase :", _viewPhase);
    // if (props.step >= 0) {
    // if (props.currentPhase === _viewPhase) {
    //   setActiveStep(props.step === 0 ? props.step : props.step - 1);
    // } else if (props.currentPhase < _viewPhase) {
    //   setActiveStep(-1);
    // } else {
    //   setActiveStep(1000);
    // }
    // }
    //eslint-disable-next-line
    setActiveStep(props.step);
    console.log("Active Step2:", props.step);
  }, [props.step, props.phase]);

  useEffect(() => {
    if (props.phase) setActiveWorkflow(props.phase);
    //eslint-disable-next-line
    console.log("Active Step2:", props.phase);
  }, [props.phase]);

  //   useEffect(() => {
  //     //eslint-disable-next-line
  //     console.log("Active phase:", props.currentPhase);
  // if(props.currentPhase===(props.phase-1)){
  //   setPhaseStatus()
  // }

  //     console.log("Active Workflow:", activeWorkflow);
  //   }, [props.currentPhase]);

  return (
    <React.Fragment>
      {openDesignTool && (
        <ShowDesignerTool
          showDialog={openDesignTool}
          handleClose={handleDesignToolClose}
        />
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            width: "25%",
          }}
        ></Box>
        <Stepper activeStep={activeStep} orientation='vertical'>
          {activeWorkflow &&
            activeWorkflow.ProcessSteps &&
            activeWorkflow.ProcessSteps.map((step, index) => (
              <Step key={step.Name}>
                <StepLabel>{step.Name}</StepLabel>
                <StepContent>
                  <Typography>{step.Description}</Typography>
                  <Box sx={{ mb: 2 }}>
                    <div>
                      {step.hasDesignAction && (
                        <Button
                          variant='contained'
                          color='secondary'
                          sx={{ mt: 1, mr: 1 }}
                          onClick={handleClickOpenDesignTool}
                          disabled={
                            hasUserAccessToProject &&
                            !hasUserAccessToProject(
                              props?.projectId ? props?.projectId : ""
                            ) &&
                            getUserRoleType &&
                            getUserRoleType() !== "Central GIS Team"
                          }
                        >
                          {step.DesignAction}
                        </Button>
                      )}
                      {step.hasCommentAction && (
                        <Button
                          onClick={() => handleNext(step)}
                          color='secondary'
                          variant='contained'
                          sx={{ mt: 1, mr: 1 }}
                        >
                          {step.CommentAction}
                        </Button>
                      )}
                      <Button
                        onClick={() => handleNext(step)}
                        variant='contained'
                        sx={{ mt: 1, mr: 1 }}
                        disabled={
                          hasUserAccessToProject &&
                          !hasUserAccessToProject(
                            props?.projectId ? props?.projectId : ""
                          ) &&
                          getUserRoleType &&
                          getUserRoleType() !== "Central GIS Team"
                        }
                      >
                        Mark as Complete
                      </Button>
                    </div>
                  </Box>
                </StepContent>
              </Step>
            ))}
        </Stepper>
        {/* {activeStep === steps.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset
          </Button>
        </Paper>
      )} */}
      </Box>
    </React.Fragment>
  );
}
